import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Ecole from '../views/Ecole.vue'
import CoursJaponais from '../views/CoursJaponais.vue'
import Niveau from '../views/Niveau.vue'
import LegalMentions from '../views/LegalMentions.vue'
import Contact from '../views/Contact.vue'
import Developpeur from '../views/Developpeur.vue'
import Recrutement from '../views/Recrutement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/adlcj',
    name: 'Adlcj',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Adlcj.vue')
  },
  {
    path: '/ecole',
    name: 'Ecole',
    component: Ecole
  },
  {
    path: '/cours-japonais',
    name: 'CoursJaponais',
    component: CoursJaponais
  },
  {
    path: '/cours-japonais/niveau',
    name: 'Niveau',
    component: Niveau
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  
  {
    path: '/mentions-legales',
    name: 'LegalMentions',
    component: LegalMentions
  },
  {
    path: '/developpeur',
    name: 'Developpeur',
    component: Developpeur
  },
  {
    path: '/recrutement',
    name: 'Recrutement',
    component: Recrutement
 },
  {
    // 一致するルートがない場合、すべてここにキャッチされる
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
